export default function () {
    $("#page-index").on('change', function () {
        $("#page-select-form").trigger('submit');
    });
}
